import React from 'react'

export const ForgotEmailConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/forgotEmail',
            component: React.lazy(() => import('./ForgotEmail')),
            applicationPath: 'ForgotEmail'
        }
    ]
}

